import { Instance, types } from 'mobx-state-tree';

import { CreditCardType, CreditCardTypes } from '../../../../../external/shared/api/EnrollmentClient.generated';
import { getRootStore } from '../../../../root/RootStoreUtils';

async function loadUnionPayBinList() {
  return await import('./union-pay-bins');
}

let unionPayBinListPromise: ReturnType<typeof loadUnionPayBinList> | undefined;

export async function getUnionPayBinList() {
  unionPayBinListPromise ??= loadUnionPayBinList();
  return await unionPayBinListPromise;
}

export const CardTypeMatcher = types
  .model({})
  .views(self => ({
    get cardTypes(): CreditCardType[] | undefined {
      return getRootStore(self).moduleStores.billingEntry!.creditCardConfig.cardTypes;
    },
    get unionPayType() {
      return this?.cardTypes?.find(x => x.value === CreditCardTypes.UnionPay);
    },
    isMaybeAMEX(cardNumber: string) {
      const amexType = this?.cardTypes?.find(x => x.value === CreditCardTypes.AMEX);
      if (!amexType?.regex) return false;
      return new RegExp(amexType.regex).test(cardNumber);
    },
    async getCardType(cardNumber: string) {
      if (this.unionPayType) {
        const { unionPayBinList } = await getUnionPayBinList();
        if (unionPayBinList.find(bin => cardNumber.startsWith(bin))) return this.unionPayType;
      }
      return this?.cardTypes?.find(x => x.regex && new RegExp(x.regex).test(cardNumber));
    }
  }))
  .actions(self => ({
    warmUp() {
      if (self.unionPayType) {
        getUnionPayBinList();
      }
    }
  }));

export type CardTypeMatcher = Instance<typeof CardTypeMatcher>;
